import React from 'react';
import { useHistory } from 'react-router';
import { Box, Button, Text, Title } from '@nimbus-ds/components';
import AppLayout from 'App/components/AppLayout';
import { DesktopCard } from 'commons/components';
import { useTranslationWithPrefix } from 'commons/utils';

function PepOrSoInfo(): JSX.Element {
  const { t } = useTranslationWithPrefix('identityValidation');
  const { goBack } = useHistory();

  const InfoBox = ({
    title,
    description,
  }: {
    title: string;
    description: string;
  }) => (
    <Box>
      <Title as="h5" color="neutral-textHigh" fontWeight="bold">
        {t(`notEligible.${title}`)}
      </Title>
      <Text color="neutral-textLow">{t(`notEligible.${description}`)}</Text>
    </Box>
  );

  return (
    <AppLayout
      title={t('title')}
      footer={
        <Box>
          <Button appearance="primary" onClick={goBack}>
            {t('buttons.understand')}
          </Button>
        </Box>
      }
    >
      <DesktopCard>
        <Box display="flex" flexDirection="column" gap="3">
          <InfoBox
            title="obligatedSubject"
            description="obligatedSubjectDescription"
          />
          <InfoBox
            title="exposedPerson"
            description="exposedPersonDescription"
          />
        </Box>
      </DesktopCard>
    </AppLayout>
  );
}

export default PepOrSoInfo;
